import { BlueBanner } from 'shared/components/BlueBanner';
import { SMB_PRE_FOOTER_BANNER } from 'shared/constants/smbPreFooterBanner';

interface ISmbContentProps {
  startBlock: React.ReactNode;
  steps: React.ReactNode;
  faq?: React.ReactNode;
  socials?: React.ReactNode;
  onBlueBannerClick?: () => void;
}

export const SmbContent: React.FC<ISmbContentProps> = ({ startBlock, steps, faq, socials, onBlueBannerClick }) => {
  return (
    <div>
      {startBlock}
      {steps}
      {faq}
      <BlueBanner mainBanner={SMB_PRE_FOOTER_BANNER} page onButtonClick={onBlueBannerClick} />
      {socials}
    </div>
  );
};
